import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ep-row',
  template: '<div class="row g-0"><ng-content></ng-content></div>'
})
export class RowComponent {
  constructor() {}
}
